import { feathersCreateData } from "."
import { encrypt } from '../functions/mobile';

export const getDataAgreementsName = async (data) => {
    // const { SecuencialInstitucion,  SecuencialNivelEstudio } = data
    try {
        const getPayersName = await feathersCreateData('core-server',{
            service: 'COLLECTIONS',
            func: 'GET_PAYERS_NAME',
            data
        })()
        const {error} = getPayersName
        if (!error) {
            return Promise.resolve(getPayersName)
            /* const {data} = getPayersName
            const getPayersCode = await feathersCreateData('core-server',{
                service: 'COLLECTIONS',
                func: 'GET_PAYMENTS_CODE',
                data: { SecuencialInstitucion, SecuencialNivelEstudio, CodigoPagador: data[0].CodigoPagador }
            })()
            const { error: errorPayersCode} = getPayersCode 
            if (!errorPayersCode) {
                return Promise.resolve(getPayersCode)
            } else {
                return Promise.reject({message: 'No se a podido encontrar el cliente', type: 'error'});
            }*/
            
        } else {
            return Promise.reject({message: 'No se ha podido encontrar el cliente o no existen deudas pendientes.', type: 'error'});
        }
    } catch (error) {
        //console.log(error)
        return Promise.reject({message: 'No se ha podido encontrar el cliente.', type: 'error'});
    }
    
}


export const getDataAgreementsCode = async (data) => {
    // const { SecuencialInstitucion,  SecuencialNivelEstudio, CodigoPagador } = data
    // console.log(data)
    try {
        const getPayersCode = await feathersCreateData('core-server',{
            service: 'COLLECTIONS',
            func: 'GET_PAYMENTS_CODE',
            data
        })()
        const { error: errorPayersCode, data: dataPayersCode} = getPayersCode
        // console.log(getPayersCode)
        if (!errorPayersCode && dataPayersCode !== null ) {
            return Promise.resolve(getPayersCode)
        } else {
            return Promise.reject({message: 'No existen deudas pendientes.', type: 'info'});
        }
    } catch (error) {
        //console.log(error)
        return Promise.reject({message: 'No se ha podido encontrar el código solicitado.', type: 'error'});
    }
    
}

export const processPaymentAgreements = async (data) => {
    // const { CadenaListaRecuadacionesCobradas, SecuencialCuenta, SecuencialEmpresa, Concepto, MontoTotal } = data
    try {
        const processPayment = await feathersCreateData('core-server',{
            service: 'COLLECTIONS',
            func: 'PAYMENT_PROCESS',
            data
        })()
        const {error} = processPayment
        if (error) 
            return Promise.reject({message: 'No se ha podido realizar la transferencia.', type: 'error'});
        else 
            return Promise.resolve(processPayment)
    } catch (error) {
        //console.log(error)
        return Promise.reject({message: 'No se ha podido realizar la transacción.', type: 'error'});
    }
    
}


export const processGetCreditsAditionalPayment = async (data) => {
    // const { CadenaListaRecuadacionesCobradas, SecuencialCuenta, SecuencialEmpresa, Concepto, MontoTotal } = data
    try {
        const processPayment = await feathersCreateData('core-server',{
            service: 'LOANS',
            func: 'GET_LOANS_ADITIONAL_INFO',
            data
        })()
        const {error} = processPayment
        if (error) 
            return Promise.reject({message: 'No se ha podido realizar la transferencia.', type: 'error'});
        else 
            return Promise.resolve(processPayment)
    } catch (error) {
        //console.log(error)
        return Promise.reject({message: 'No se ha podido realizar la transacción.', type: 'error'});
    }
    
}
// pago de prestamos
export const processCreditsPay = async (data) => {
    // const { CadenaListaRecuadacionesCobradas, SecuencialCuenta, SecuencialEmpresa, Concepto, MontoTotal } = data
    try {
        const processPayment = await feathersCreateData('core-server',{
            service: 'LOANS',
            func: 'LOANS_PROCESS_PAY',
            data
        })()
        const {error} = processPayment
        if (error) 
            return Promise.reject(processPayment);
        else 
            return Promise.resolve(processPayment)
    } catch (error) {
        //console.log(error)
        return Promise.reject({message: 'No se ha podido realizar el pago.', type: 'error'});
    }
    
}

export const getSecurityTokenService = async () => {
    // const { CadenaListaRecuadacionesCobradas, SecuencialCuenta, SecuencialEmpresa, Concepto, MontoTotal } = data
    try {
        const processPayment = await feathersCreateData('core-server',{
            service: 'SECURITY',
            func: 'TOKEN_SERVICE',
            data : {} 
        })()
        const {error} = processPayment
        if (error) 
            return Promise.reject(processPayment);
        else 
            return Promise.resolve(processPayment)
    } catch (error) {
        //console.log(error)
        return Promise.reject({message: 'No se ha podido obtener información del estado del servicio. Por favor vuelva a intentar.', type: 'error'});
    }
    
}

//solicitud de OTP general
export const GetOTP = async (type, ip, mac, device) => {
    // const { CadenaListaRecuadacionesCobradas, SecuencialCuenta, SecuencialEmpresa, Concepto, MontoTotal } = data
    try {
        const sendData = encrypt(JSON.stringify({emited: 'NAVCREATECODE', type, deviceData: device, ip, mac }))
        const processOTP = await feathersCreateData('codes-recovery', { sendData })()
        return Promise.resolve(processOTP)
    } catch (error) {
        //console.log(error)
        return Promise.reject({message: 'No se logró obtener el código OTP.', type: 'error'});
    }
    
}

export const getSiimPayReferences = async (data) => {
    // const { CadenaListaRecuadacionesCobradas, SecuencialCuenta, SecuencialEmpresa, Concepto, MontoTotal } = data
    try {
        const siimPayReferences = await feathersCreateData('core-server',{
            service: 'COLLECTIONS_SIIM',
            func: 'GET_SIIM_PAY_REFERENCES',
            data
        })()
        const {error} = siimPayReferences
        if (error) 
            return Promise.reject({message: 'No se ha podido realizar el pago.', type: 'error'});
        else 
            return Promise.resolve({message: 'Pago realizado con éxito.', type: 'success', data: siimPayReferences})
    } catch (error) {
        //console.log(error)
        return Promise.reject({message: 'No se ha podido realizar el pago.', type: 'error'});
    }
    
}
export const processPaymentSiim = async (data) => {
    // const { CadenaListaRecuadacionesCobradas, SecuencialCuenta, SecuencialEmpresa, Concepto, MontoTotal } = data
    try {
        const processPayment = await feathersCreateData('core-server',{
            service: 'COLLECTIONS_SIIM',
            func: 'COLLECTIONS_PROCESS_PAYMENT_SIIM',
            data
        })()
        const {error} = processPayment
        if (error) 
            return Promise.reject({message: 'No se ha podido realizar la transferencia.', type: 'error'});
        else 
            return Promise.resolve(processPayment)
    } catch (error) {
        //console.log(error)
        return Promise.reject({message: 'No se ha podido realizar la transacción.', type: 'error'});
    }
    
}

export const processPaymentCertificate= async (data) => {
    // const { CadenaListaRecuadacionesCobradas, SecuencialCuenta, SecuencialEmpresa, Concepto, MontoTotal } = data
    try {
        const processPayment = await feathersCreateData('core-server',{
            service: 'CERTIFICATES',
            func: 'PAY_PROCESS',
            data
        })()
        const {error} = processPayment
        if (error) 
            return Promise.reject({message: 'No se ha podido realizar la transferencia.', type: 'error'});
        else 
            return Promise.resolve(processPayment)
    } catch (error) {
        //console.log(error)
        return Promise.reject({message: 'No se ha podido realizar la transacción.', type: 'error'});
    }
    
}

export const processPaymentCertificateOtp= async (data) => {
    // const { CadenaListaRecuadacionesCobradas, SecuencialCuenta, SecuencialEmpresa, Concepto, MontoTotal } = data
    try {
        const processPayment = await feathersCreateData('core-server',{
            service: 'CERTIFICATES',
            func: 'PAY_PROCESS_OTP',
            data
        })()
        const {error} = processPayment
        if (error) 
            return Promise.reject({message: 'No se ha podido realizar la transferencia.', type: 'error'});
        else 
            return Promise.resolve(processPayment)
    } catch (error) {
        //console.log(error)
        return Promise.reject({message: 'No se ha podido realizar la transacción.', type: 'error'});
    }
    
}

export const processValidateCertificate= async (data) => {
    // const { CadenaListaRecuadacionesCobradas, SecuencialCuenta, SecuencialEmpresa, Concepto, MontoTotal } = data
    try {
        const processValidating = await feathersCreateData('certificate-validates',data)()
        // console.log(processValidating)
        const {error} = processValidating
        if (error) 
            return Promise.reject({message: processValidating.message.split('|')[0], type: 'error'});
        else 
            return Promise.resolve(processValidating)
    } catch (error) {
        //console.log(error)
        return Promise.reject({message: 'No se ha podido realizar la validación.', type: 'error'});
    }
    
}